import { render, staticRenderFns } from "./RemoveDomain.vue?vue&type=template&id=1a98e2c4&"
import script from "./RemoveDomain.vue?vue&type=script&lang=ts&"
export * from "./RemoveDomain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports